export const FilesDictionary: { [id: string]: File } = {};
